// import userReducer from '@app/store/slices/userSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import voucherReducer from '@app/store/slices/voucherSlice';
export default {
  voucherSlice: voucherReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
};
